import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/userGroups/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_DEFAULT_OWNER_USER_GROUP_ID = NAMESPACE + 'SET_DEFAULT_OWNER_USER_GROUP_ID'
export const SET_DEFAULT_MEMBER_USER_GROUP_ID = NAMESPACE + 'SET_DEFAULT_MEMBER_USER_GROUP_ID'
export const SET_DEFAULT_VISITOR_USER_GROUP_ID = NAMESPACE + 'SET_DEFAULT_VISITOR_USER_GROUP_ID'

const userGroupDefaults = {
  permissionLevel: 0
}

const defaultBoardState = {
  userGroups: [],
  userGroupsById: {},
  defaultOwnerUserGroupId: null,
  defaultMemberUserGroupId: null,
  defaultVisitorUserGroupId: null,
  loading: false,
  loaded: false
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          loading: action.payload.loading,
          loaded: action.payload.loaded
        }
      } : state
    case ADD:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          userGroups: addUniqueValueToArray({
            array: state[action.payload.boardId].userGroups,
            value: action.payload.userGroup.id,
            index: action.payload.userGroup.index
          }),
          userGroupsById: {
            ...state[action.payload.boardId].userGroupsById,
            [action.payload.userGroup.id]: {
              ...userGroupDefaults,
              ...action.payload.userGroup
            }
          }
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          userGroups: [ ...state[action.payload.boardId].userGroups ],
          userGroupsById: { ...state[action.payload.boardId].userGroupsById }
        }
      }

      action.payload.array.forEach(item => {
        newState[action.payload.boardId].userGroups = addUniqueValueToArray({
          array: newState[action.payload.boardId].userGroups,
          value: item.id,
          index: item.index
        })
        newState[action.payload.boardId].userGroupsById[item.id] = {
          ...userGroupDefaults,
          ...item
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          userGroups: state[action.payload.boardId].userGroups.filter(id => id !== action.payload.userGroupId),
          userGroupsById: { ...state[action.payload.boardId].userGroupsById }
        }
      }

      delete newState[action.payload.boardId].userGroupsById[action.payload.userGroupId]

      return newState
    }
    case SET_DEFAULT_OWNER_USER_GROUP_ID:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          defaultOwnerUserGroupId: action.payload.userGroupId,
        }
      } : state
    case SET_DEFAULT_MEMBER_USER_GROUP_ID:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          defaultMemberUserGroupId: action.payload.userGroupId,
        }
      } : state
    case SET_DEFAULT_VISITOR_USER_GROUP_ID:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          defaultVisitorUserGroupId: action.payload.userGroupId,
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ boardId, loading, loaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      loading,
      loaded
    }
  }
}

export function add ({ boardId, userGroup }) {
  return {
    type: ADD,
    payload: {
      boardId,
      userGroup
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array
    }
  }
}

export function remove ({ boardId, userGroupId }) {
  return {
    type: REMOVE,
    payload: {
      boardId,
      userGroupId
    }
  }
}

export function setDefaultOwnerUserGroupId ({ boardId, userGroupId }) {
  return {
    type: SET_DEFAULT_OWNER_USER_GROUP_ID,
    payload: {
      boardId,
      userGroupId
    }
  }
}
export function setDefaultMemberUserGroupId ({ boardId, userGroupId }) {
  return {
    type: SET_DEFAULT_MEMBER_USER_GROUP_ID,
    payload: {
      boardId,
      userGroupId
    }
  }
}
export function setDefaultVisitorUserGroupId ({ boardId, userGroupId }) {
  return {
    type: SET_DEFAULT_VISITOR_USER_GROUP_ID,
    payload: {
      boardId,
      userGroupId
    }
  }
}